import { activityEventUpdate } from 'fmc-digital-common';
import { localStorageHelper } from './localStorageHelpder';
import { logApiEvent } from '@analytics/amplifyLogging';

export const storeMigrationData = (loanNumber: string, url: string) => {
    const cardsArr: any = {
        'welcome-onboarding': 'OB-Welcome',
        'tcpa-onboarding': 'OB-TCPA',
        'capture-mobile-onboarding': 'OB-TCPA',
        'paperless-onboarding': 'OB-Paperless',
        'mobileapp-download-onboarding': 'OB-MobileApp'
    };
    const { getItems, setItem } = localStorageHelper;
    const localData = getItems('AppPreferences') || {};
    if (Object.keys(localData).length > 0 && !localData.migrated) {
        const requestData = Object.keys(localData).map((key: any) => {
            return {
                activityType: String(cardsArr[key]),
                activityResult: 'SHOWN',
                ...(key === 'paperless-onboarding' && { loanNumber: loanNumber })
            };
        });
        try {
            activityEventUpdate(requestData, url);
            setItem('AppPreferences', 'migrated', 'complete', -1);
        } catch (error) {
            console.log(error);
        }
    }
};
